import { render, staticRenderFns } from "./feedbackRecord.vue?vue&type=template&id=5b657148&scoped=true&"
import script from "./feedbackRecord.vue?vue&type=script&lang=ts&"
export * from "./feedbackRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b657148",
  null
  
)

export default component.exports